import {FC} from 'react';
import SvgIcon, {SvgIconProps} from '@mui/material/SvgIcon';

export const ExcelIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon
        {...props}
        arial-label='Excel File'
        role='img'
        viewBox='-3 -2 22 24'
    >
        <path
            d='M2 0C.9 0 .01.9.01 2L0 18c0 1.1.89 2 1.99 2H14c1.1 0 2-.9 2-2V6l-6-6H2zm7 7V1.5L14.5 7H9zm-2.34 7.39l-3.45-5.1h2.73l2.1 3.42 2.175-3.42h2.58L9.36 14.405 13.095 20H10.29l-2.34-3.705L5.565 20h-2.64l3.735-5.61z'
            fillRule='nonzero'
        />
    </SvgIcon>
);
